export default (AutoOption) => {
	return class extends AutoOption {
		constructor(option) {
			const context = option.context
			const $hzeroHttp = context.$hzeroHttp
			const hzeroOption = option.hzero || {}

			hzeroOption.requestProcessor = hzeroOption.requestProcessor || {}						// 请求参数格式化函数，用来格式化请求参数
			hzeroOption.requestHandler = hzeroOption.requestHandler || {}							// 自定义请求处理函数，如果存在，则返回自定义请求函数的结果

			option = Object.assign({
				combineSearchButton: false,															// 默认禁用组合查询
				async requestFunc(url, param, formatFormParam, requestMethod, requestType) {
					const requestHandler = {
						queryByExamplePage: async () => {
							let config = {
								url,
								method: 'get',
								params: {
									page: param.page - 1,
									size: param.rows,
								},
							}

							if (!!hzeroOption.requestProcessor.queryByExamplePage) {
								config = await hzeroOption.requestProcessor.queryByExamplePage.apply(context, [config]) || config
							}

							const {data} = await $hzeroHttp(config)
							const {content, totalElements, failed} = data

							if (failed) {
								throw data
							}

							return {
								success: true,
								rows: content,
								total: totalElements,
							}
						},
						insert: async () => {

							let config = {
								method: 'post',
								url,
								data: param
							}

							if (!!hzeroOption.requestProcessor.insert) {
								config = await hzeroOption.requestProcessor.insert.apply(context, [config]) || config
							}

							const {data} = await $hzeroHttp(config)
							if (data.failed) {
								throw data
							}
							return {
								newRow: data,
								success: true,
							}
						},
						update: async () => {

							let config = {
								method: 'put',
								url,
								data: param
							}

							if (!!hzeroOption.requestProcessor.update) {
								config = await hzeroOption.requestProcessor.update.apply(context, [config]) || config
							}

							const {data} = await $hzeroHttp(config)
							if (data.failed) {
								throw data
							}
							return {
								newRow: data,
								success: true,
							}
						},
						deleteById: async () => {

							let config = {
								method: 'delete',
								url,
							}

							if (!!hzeroOption.requestProcessor.deleteById) {
								config = await hzeroOption.requestProcessor.deleteById.apply(context, [config]) || config
							}

							const {data} = await $hzeroHttp(config)
							if (data.failed) {
								throw data
							}
							return {
								success: true,
							}
						},
						default: async () => {
							return {
								success: false,
								result: '该功能未实现'
							}
						},
					}
					try {
						if (!!hzeroOption.requestHandler[requestType]) {
							return hzeroOption.requestHandler[requestType].apply(context, [url, param, formatFormParam, requestMethod, requestType])
						}
						if (!!requestHandler[requestType]) {
							return await requestHandler[requestType]()
						} else {
							return await requestHandler.default()
						}
					} catch (e) {
						console.error(e)
						return {
							result: e.message,
							success: false,
						}
					}
				},
			}, option)

			super(option)
		}
	}
}